import React, { useEffect } from 'react';
import CustomersView from './CustomersView';
import { useShopFilter } from '../shops/hooks/useShopFilter';
import { ShopFilter } from '../shops/components/ShopFilter';
import { useSubscriptionStatus } from '@/hooks/useSubscriptionStatus';
import { SubscriptionLock } from '@/components/subscription/SubscriptionLock';
import LoadingSpinner from '../products/components/LoadingSpinner';

interface CustomersProps {
  handlePageChange?: (pageId: string) => void;
}

const Customers = ({ handlePageChange }: CustomersProps) => {
  const { isSubscriptionActive, isLoading: isSubscriptionLoading } = useSubscriptionStatus();
  
  // Use shop filter hook to get selected shop
  const { 
    singleSelectedShop,
    selectedShops,
    toggleShopSelection,
    setSingleSelectedShop,
    shops,
    isLoading: loadingShops,
    isCollapsed,
    setIsCollapsed,
    refreshShops
  } = useShopFilter();
  
  // Use shopId from localStorage or from the filter state
  const shopId = singleSelectedShop || localStorage.getItem('selectedShopId') || undefined;
  
  // Handle shop selection properly
  const handleShopSelection = (id: string) => {
    console.log('Shop selection in Customers component:', id);
    setSingleSelectedShop(id);
  };
  
  // Render the shop filter regardless of subscription status
  const renderShopFilter = () => {
    return (
      <ShopFilter 
        isSingleSelectionMode={true}
        selectedShops={selectedShops}
        singleSelectedShop={singleSelectedShop}
        toggleShopSelection={handleShopSelection}
        shops={shops}
        isLoading={loadingShops}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        refreshShops={refreshShops}
      />
    );
  };
  
  // Show loading state when checking subscription
  if (isSubscriptionLoading || isSubscriptionActive === null) {
    return (
      <div className="flex h-full">
        {renderShopFilter()}
        <div className="flex-1 bg-pastel-blue-light dark:bg-[#121624]">
          <div className="h-full w-full flex items-center justify-center">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }
  
  // Check if subscription is active
  if (isSubscriptionActive === false) {
    return (
      <div className="flex h-full">
        {renderShopFilter()}
        <div className="flex-1 bg-pastel-blue-light dark:bg-[#121624]">
          <SubscriptionLock 
            title="Gestion des clients verrouillée"
            description="La gestion des clients n'est disponible qu'avec un abonnement actif."
            buttonText="Débloquer la gestion des clients"
          />
        </div>
      </div>
    );
  }
  
  // If subscription is active, render the customers view
  return (
    <div className="flex h-full">
      {renderShopFilter()}
      
      {/* Main content area */}
      <div className="flex-1 overflow-auto">
        <CustomersView 
          shopId={shopId}
          handlePageChange={handlePageChange}
          key={shopId} // Add key to force re-render when shop changes
        />
      </div>
    </div>
  );
};

export default Customers;
